<template>
    <div>
        <div class="content-heading">
            <i class="ic-head-icon">
                <img src="@/assets/images/settings.svg" alt="">
            </i>
            <h4 class="head-title">Activity Logs</h4>
            <i class="ic-tooltip" id="help"></i>
            <b-popover 
                target="help"
                triggers="hover"
                content="This section allows you to update your general account information including the terms of use of your loyalty program."
            >
            </b-popover>
            <div class="head-tabs">
                <b-nav tabs>
                    <b-nav-item :to="{ path: '/activity/logs'}">
                        Logs
                    </b-nav-item>
                </b-nav>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    name: "ActivityLogPage",
    data() {
        return {
            
        };
    },
};
</script>

<style scoped>
</style>
